import { useState , useEffect} from "react";
import Select from "react-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { useAssignBulkVariantsbyProductMutation } from "../../Services/StockManagemntAPI";
import { useGetVarientsbyCategoryIdQuery , useGetVariantbyProductIdQuery } from "../../Services/StockManagemntAPI";

function Addvarients() {
    const navigate = useNavigate();
    const { productId } = useParams();
    const [apiError, setApiError] = useState(null);
    const [addVarients, { isLoading }] = useAssignBulkVariantsbyProductMutation();

    const { data: allVariants } = useGetVarientsbyCategoryIdQuery();
    const {data:variantsByProductId} = useGetVariantbyProductIdQuery(productId);
    const [selectedVariants, setSelectedVariants] = useState({});

    console.log("variantsByProductId", variantsByProductId);

    const handleDropdownChange = (attributeId, selectedOptions) => {
        setSelectedVariants(prev => ({
            ...prev,
            [attributeId]: selectedOptions || []
        }));
    };


    useEffect(() => {
        if (variantsByProductId?.variants?.length) {
            const preSelected = {};
            variantsByProductId.variants.forEach(variant => {
                preSelected[variant.id] = variant.values.map(v => ({
                    value: v.value,
                    label: v.value,
                    id: v.id
                }));
            });
            setSelectedVariants(preSelected);
        }
    }, [variantsByProductId]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formattedVariants = Object.entries(selectedVariants).map(([attributeId, values]) => ({
            variant_attribute_id: parseInt(attributeId),
            values: values.map(v => v.id)
        }));

        const payload = {
            product_id: parseInt(productId),
            variants: formattedVariants
        };

        try {
            await addVarients(payload).unwrap();
            alert("Variant added successfully!");
            setSelectedVariants({});
            setApiError(null);
            navigate(`/list-varients-by-product/${productId}`);
        } catch (error) {
            setApiError(error.data?.message || "Something went wrong");
        }
    };

    return (
        <div>
            <h3>Edit Variants</h3>
           <div className="breadcrum mb-4">
                    <p onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
                        <FontAwesomeIcon icon={faAngleLeft} className="mx-2" />
                        <span>Back</span>
                    </p>
                </div>

            <div className="content-wrapper">
                <form onSubmit={handleSubmit}>

                    {/* React Multi-Select */}
                    <div className="row">
                        {allVariants?.map(variant => (
                            <div className="col-md-6 mb-3" key={variant.id}>
                                <label className="form-label">{variant.name}</label>
                                <Select
                                    isMulti
                                    options={variant.values.map(v => ({
                                        value: v.value,
                                        label: v.value,
                                        id: v.id
                                    }))}
                                    value={selectedVariants[variant.id] || []}
                                    onChange={(selected) => handleDropdownChange(variant.id, selected)}
                                />
                            </div>
                        ))}
                    </div>

                    {/* Error message */}
                    {apiError && <p className="text-danger text-center">{apiError}</p>}

                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                        {isLoading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
    );
}

export default Addvarients;
